import React from 'react';

const LanguageSelectFlag = ({ children }) => (
  <div className="ws-ui-language-select-flag">{children}</div>
);

export default LanguageSelectFlag;
